import { createFileRoute, redirect, RouteContext } from '@tanstack/react-router'

import { TaxWorkerDetailsLoading } from '@/containers/taxDetails/TaxWorkerDetailsLoading'
import { orgInfoQueryOptions } from '@/queries/organization'
import { taxWorkerDetailsQueryOptions } from '@/queries/tax'
import { selectOrgData } from '@/selectors/organization'

export const Route = createFileRoute(
  '/_authenticated/account/_accountDetails/taxDetails'
)({
  pendingComponent: TaxWorkerDetailsLoading,
  beforeLoad: async ({ context: { queryClient, orgStore } }) => {
    const data = queryClient.getQueryData(
      orgInfoQueryOptions(orgStore.getState().orgId).queryKey
    )
    const { onboardingRequireW9Collection } = selectOrgData(data)

    if (!onboardingRequireW9Collection) {
      redirect({ to: '/account', throw: true })
    }

    try {
      await queryClient.ensureQueryData(taxWorkerDetailsQueryOptions)
    } catch {
      redirect({ to: '/account', throw: true })
    }

    const routeContext: RouteContext = {
      title: 'Taxes',
      breadCrumbTitle: null,
      subTitle: 'Manage tax info and documents.',
      subNavLinks: [
        {
          to: '/account/taxDetails',
          activeOptions: { exact: true, includeSearch: false },
          label: 'Taxpayer',
        },
      ],
    }
    return routeContext
  },
})
